import React from 'react';
import Link from 'next/link';
import { ArrowRight } from 'lucide-react';

const categories = [
  { id: 'cat-food', emoji: '🍽️', label: 'Food & Dining', bg: 'from-orange-50 to-red-50' },
  { id: 'cat-beauty', emoji: '💄', label: 'Beauty & Salon', bg: 'from-pink-50 to-rose-50' },
  { id: 'cat-fitness', emoji: '🏋️', label: 'Fitness & Gym', bg: 'from-blue-50 to-indigo-50' },
  { id: 'cat-grocery', emoji: '🛒', label: 'Grocery & Fresh', bg: 'from-green-50 to-emerald-50' },
  { id: 'cat-fashion', emoji: '👗', label: 'Fashion & Retail', bg: 'from-purple-50 to-violet-50' },
  { id: 'cat-cafe', emoji: '☕', label: 'Cafés & Bakeries', bg: 'from-amber-50 to-yellow-50' },
  { id: 'cat-health', emoji: '💊', label: 'Health & Pharmacy', bg: 'from-teal-50 to-cyan-50' },
  { id: 'cat-auto', emoji: '🚗', label: 'Auto & Services', bg: 'from-slate-50 to-gray-50' },
];

export default function LandingCategories() {
  return (
    <section className="py-20 bg-background">
      <div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-end justify-between mb-10">
          <div>
            <p className="section-label mb-3">Browse by category</p>
            <h2 className="text-hero-md text-foreground">
              Find offers in every{' '}
              <span className="gradient-brand-text">category</span>
            </h2>
          </div>
          <Link href="/customer-home-discover" className="hidden sm:flex items-center gap-2 text-sm font-semibold text-primary hover:underline">
            View all <ArrowRight size={16} />
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {categories?.map((cat) => (
            <Link
              key={cat?.id}
              href="/customer-home-discover"
              className={`card-elevated card-hover rounded-2xl p-5 bg-gradient-to-br ${cat?.bg} border-0 block group`}
            >
              <div className="text-3xl mb-3">{cat?.emoji}</div>
              <h3 className="text-sm font-700 font-bold text-foreground mb-1 group-hover:text-primary transition-colors">
                {cat?.label}
              </h3>
            </Link>
          ))}
        </div>

        <div className="text-center mt-6 sm:hidden">
          <Link href="/customer-home-discover" className="btn-outline text-sm px-5 py-2.5">
            View all categories <ArrowRight size={15} />
          </Link>
        </div>
      </div>
    </section>
  );
}